module.exports = __webpack_public_path__ + "img/error.d426093a.png";